import cn from 'classnames';
import Image from 'next/image';
import Link from 'next/link';
import Button from 'react-scale/components/elements/button';

const EventsBanner = ({ date, title, speakers, withCalendarIcon, cta }) => (
  <div className="text-white bg-black border-b border-neutral-800">
    <div className="container">
      <div className="flex flex-col items-center gap-4 py-3 text-sm sm:flex-row sm:justify-between">
        <Link href={cta.href}>
          <SpeakerBanner
            title={title}
            date={date}
            speakers={speakers}
            withCalendarIcon={withCalendarIcon}
          />
        </Link>
        <div className="hidden sm:block">
          <Button
            text={cta.text}
            href={cta.href}
            type={cta.type}
            variant={cta.variant}
            size={cta.size}
          />
        </div>
      </div>
    </div>
  </div>
);

const SpeakerBanner = ({ title, date, speakers, withCalendarIcon }) => (
  <div
    className={cn(
      'flex items-start sm:items-center',
      withCalendarIcon ? 'gap-4 sm:gap-1' : 'gap-4'
    )}
  >
    {withCalendarIcon ? (
      <div className="shrink-0 -mt-0.5">
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9 3.75V5.25C9 5.66421 8.66421 6 8.25 6C7.83579 6 7.5 5.66421 7.5 5.25V3.75V3.75C7.5 3.33579 7.83579 3 8.25 3C8.66421 3 9 3.33579 9 3.75V3.75ZM20.25 6V18.75C20.25 19.5784 19.5784 20.25 18.75 20.25H5.25V20.25C4.42157 20.25 3.75 19.5784 3.75 18.75V6V6C3.75 5.17157 4.42157 4.5 5.25 4.5H6.375V4.5C6.58211 4.5 6.75 4.66789 6.75 4.875V5.18558V5.18558C6.73686 5.97403 7.32017 6.6456 8.1027 6.74295V6.74295C8.92727 6.82418 9.66155 6.22158 9.74277 5.39702C9.74759 5.34816 9.75 5.29909 9.75 5.25V4.875V4.875C9.75 4.66789 9.91789 4.5 10.125 4.5H13.875V4.5C14.0821 4.5 14.25 4.66789 14.25 4.875V5.18557V5.18557C14.2369 5.974 14.8201 6.64555 15.6026 6.74295V6.74295C16.4272 6.8242 17.1615 6.22161 17.2428 5.39703C17.2476 5.34817 17.25 5.2991 17.25 5.25V4.875V4.875C17.25 4.66789 17.4179 4.5 17.625 4.5H18.75V4.5C19.5784 4.5 20.25 5.17157 20.25 6C20.25 6 20.25 6 20.25 6V6ZM18.375 10.5H5.625V10.5C5.41789 10.5 5.25 10.6679 5.25 10.875V10.875V18.375V18.375C5.25 18.5821 5.41789 18.75 5.625 18.75H18.375V18.75C18.5821 18.75 18.75 18.5821 18.75 18.375V10.875C18.75 10.6679 18.5821 10.5 18.375 10.5V10.5ZM15.75 3V3C16.1642 3 16.5 3.33579 16.5 3.75V5.25C16.5 5.66421 16.1642 6 15.75 6C15.3358 6 15 5.66421 15 5.25V3.75V3.75C15 3.33579 15.3358 3 15.75 3V3Z"
            fill="#D1AAD7"
          />
        </svg>
      </div>
    ) : (
      <div className={cn({ 'flex ml-1 pr-1': speakers.length > 1 })}>
        {speakers.map(speaker => (
          <div
            key={speaker.name}
            className={cn(
              'relative w-8 h-8 sm:w-10 sm:h-10 overflow-hidden shadow-sm mt-1 sm:mt-0',
              {
                '-mx-1': speakers.length > 1,
                'rounded-full': speaker.iconRounded
              }
            )}
          >
            <Image src={speaker.image} alt={speaker.alt} layout="fill" priority />
          </div>
        ))}
      </div>
    )}
    <p>
      <span className="text-scale-lightmauve block sm:inline-block mb-2 sm:mb-0">{date}:</span>{' '}
      {title}&nbsp;
      <span className="text-neutral-400">by</span>&nbsp;
      {speakers.map((speaker, i) => (
        <span key={speaker.name}>
          {speaker.name}
          {speakers.length > 1 && i !== speakers.length - 1 && (
            <span className="text-neutral-400">and&nbsp;</span>
          )}
        </span>
      ))}
    </p>
  </div>
);

EventsBanner.defaultProps = {
  date: 'Thursday March 17th - 12 PM PT:',
  title: 'Buildering Autonomous Vehicles from the ground-up',
  cta: {
    text: 'RSVP Now',
    href: '/',
    type: 'primary',
    variant: 'white-transparent',
    size: 'small'
  }
};

export default EventsBanner;
